// src/App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ContactList from './components/ContactList';
import Header from './components/Header';
import PrivateRoute from './components/PrivateRoute';
import RegistrationModal from './components/RegistrationModal';
import LoginModal from './components/LoginModal';
import { handleInstallPrompt } from './components/installPrompt';
import { GoogleOAuthProvider } from '@react-oauth/google';

const clientId = "7413451608-9b27nl311ubdbbgal2gmv33bqu81pnd2.apps.googleusercontent.com";

function App() {

  const [registrationData, setRegistrationData] = useState({});
  const [contacts, setContacts] = useState([]);
  const [smsSent, setSmsSent] = useState(0);
  const [loading, setLoading] = useState(true);
  const [userName, setUserName] = useState(localStorage.getItem('userName') || '');
  const [email, setEmail] = useState(localStorage.getItem('email') || '');
  const [token, setToken] = useState(localStorage.getItem('token') || '');
  const [isRegistrationOpen, setIsRegistrationOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(!token);

  const [totalStars, setTotalStars] = useState(0);
  const [smsToday, setSmsToday] = useState(0);
  const [smsMonth, setSmsMonth] = useState(0);
  const [pricePerSms, setPricePerSms] = useState(0);
  const [totalGanhoHoje, setTotalGanhoHoje] = useState(0);

  const fetchTotalization = async () => {
    try {
      const response = await fetch(`https://api2.apploja.com/smssender/totalizacao.php`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}` // Inclui o token no cabeçalho de autorização
        }
      });
      if (!response.ok) {
        throw new Error('Erro ao buscar os dados de totalização');
      }
      const data = await response.json();
      setTotalStars(data.totalStars || 0);
      setSmsToday(data.smsToday || 0);
      setSmsMonth(data.smsMonth || 0);
      setPricePerSms(data.pricePerSms || 0);
      console.log("Preço por SMS" + data.pricePerSms);
      setTotalGanhoHoje(data.totalGanhoHoje || 0);
    } catch (error) {
      console.error('Erro ao buscar totalização:', error);
    }
  };

  const handleRegisterOpen = (data = {}) => {
    setRegistrationData(data);
    setIsLoginOpen(false);
    setIsRegistrationOpen(true);
  };

  useEffect(() => {
    handleInstallPrompt();

    if (token) {
      fetchTotalization();
      const fetchContacts = async () => {
        try {
          const response = await fetch('https://api2.apploja.com/smssender/sms_enviar.php', {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
          if (!response.ok) {
            throw new Error('Erro ao buscar os contatos');
          }
          const data = await response.json();
          
          // Certifique-se de que os dados incluem TipoMensagem para cada contato
          const contactsWithTipoMensagem = data.contacts.map(contact => ({
            ...contact,
            TipoMensagem: contact.TipoMensagem || 1, // Valor padrão se TipoMensagem estiver ausente
          }));
      
          setContacts(contactsWithTipoMensagem);
          setLoading(false);
        } catch (error) {
          console.error('Erro na requisição:', error);
          setLoading(false);
        }
      };
      

      fetchContacts();
    } else {
      setIsLoginOpen(true); // Abre o modal de login se o token não existir
    }
  }, [token]);

  const handleUserRegistration = (newUserName, newEmail) => {
    setUserName(newUserName);
    setEmail(newEmail);
    localStorage.setItem('userName', newUserName);
    localStorage.setItem('email', newEmail);
    setIsRegistrationOpen(false);
  };

  const handleUserLogin = (token, userName, email) => {
    setToken(token);
    setUserName(userName);
    setEmail(email);
    localStorage.setItem('token', token);
    localStorage.setItem('userName', userName);
    localStorage.setItem('email', email);
    setIsLoginOpen(false);
  };

  return (
    <GoogleOAuthProvider clientId={clientId}>
    <Router>
      <div className='flex flex-col min-h-screen'>
        <Header totalStars={totalStars} smsToday={smsToday} smsMonth={smsMonth} pricePerSms={pricePerSms} totalGanhoHoje={totalGanhoHoje} />

        <main className="flex-1 px-0">
          <Routes>
            <Route
              path="/"
              element={<Navigate to="/contacts" />} // Redireciona para a lista de contatos ao iniciar
            />
            <Route
              path="/contacts"
              element={
                <PrivateRoute>
                  {loading ? (
                    <p>Carregando contatos...</p>
                  ) : (
                    <ContactList
                      initialContacts={contacts}
                      userName={userName}
                      fetchTotalization={fetchTotalization}
                      pricePerSms={pricePerSms} // Passando o pricePerSms para ContactList
                    />
                  )}
                </PrivateRoute>
              }
            />
          </Routes>
        </main>

        {/* Modais de Login e Cadastro */}
        <LoginModal
        isOpen={isLoginOpen}
        onClose={() => setIsLoginOpen(false)}
        onRegisterOpen={handleRegisterOpen}
        onLogin={(token, name, email) => console.log('Logged in', { token, name, email })}
      />
      <RegistrationModal
        isOpen={isRegistrationOpen}
        onClose={() => setIsRegistrationOpen(false)}
        onRegister={(username) => console.log('Registered', username)}
        initialData={registrationData}
      />
      </div>
    </Router>    
  </GoogleOAuthProvider>
  );
}

export default App;
